import React from 'react';
import { Link } from 'react-router-dom';

const Navigation = props => {
  const { items } = props;

  return (
    <div id="navigation">
      <div className="col-md-3" />
      <div className="col-md-6">
        <div className="row">
          {items
            .filter(item => !item.hidden)
            .map((item, index) => (
              <div className="col-md-4" key={String(index)}>
                <Link to={item.to}>
                  {item.icon && <img src={item.icon} alt=""/>}
                  <span>{item.name}</span>
                </Link>
              </div>
            ))}
        </div>
      </div>
      <div className="col-md-3" />
    </div>
  );
};

Navigation.defaultProps = {
  items: [],
  hidden: false,
};

export default Navigation;
